import { TreasuryTransaction } from '../../../../../interfaces/Treasury';
import { formatDate, formatNumber } from '../../../../../utils/helper';
import { getBank } from 'banks-ng';
import { Avatar } from 'antd';

interface TransactionTableMobileCardProps {
    item?: TreasuryTransaction;
    onClick?: () => void;
}

const TransactionTableMobileCard = ({
    item,
    onClick = () => {}
}: TransactionTableMobileCardProps) => {
    return (
        <div
            className='bg-white w-full pb-4 border-b border-gray300 mb-4'
            onClick={onClick}
        >
            <div>
                <p className='text-sm font-semibold flex items-center leading-5 text-ebony mb-[8px]'>
                    <div className='flex gap-3 items-center'>
                        <Avatar
                            size='default'
                            src={getBank(item?.bankId)?.logo}
                            style={{
                                border: '1px solid #D0D5DD',
                                background: 'transparent'
                            }}
                        />
                        <div>
                            <p>{getBank(item?.bankId)?.name}</p>
                            <p className='text-xs font-light'>
                                {item?.accountNumber ?? '--'}
                            </p>
                        </div>
                    </div>
                </p>

                <div className='flex items-center gap-x-4  gap-y-1 flex-wrap mb-[4px] '>
                    <p className='text-xs font-normal leading-[18px] text-paleSky'>
                        Date:{' '}
                        <span className='font-semibold'>
                            {formatDate(item?.createdAt)}
                        </span>
                    </p>
                    <p className='text-xs font-normal leading-[18px] text-paleSky'>
                        Type:{' '}
                        <span className='font-semibold'>{item?.type}</span>
                    </p>
                    <p className='text-xs font-normal leading-[18px] text-paleSky'>
                        Ref:{' '}
                        <span className='font-semibold'>{item?.reference}</span>
                    </p>
                </div>
                <div className='flex items-center gap-x-4  gap-y-1 flex-wrap mb-[4px] '>
                    <p className='text-xs font-normal leading-[18px] text-paleSky'>
                        Amount:{' '}
                        <span className='font-semibold'>
                            NGN{' '}
                            {formatNumber(parseFloat(item?.amount as string))}
                        </span>
                    </p>
                    <p className='text-xs font-normal leading-[18px] text-paleSky'>
                        Balance:{' '}
                        <span className='font-semibold'>
                            NGN{' '}
                            {formatNumber(parseFloat(item?.balance as string))}
                        </span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TransactionTableMobileCard;
